import React from "react"
import "../styles/DownloadBody.css"

export default function News() {
  return (
    <main>
      <div className="download-background">
        <div className="download-container">
          <img className="title-download" src="/logo.png" alt="Logo" />
          <h2>Here you will find the News about Dangerous Digestion</h2>
        </div>
      </div>
    </main>
  )
}
